import { combineReducers } from 'redux';

const cartMergeInitialState = {
  query: {
    couponCode: '',
    actId: '',
    freePost: '',
  },
  data: null,
  loadStatus: 0,
  saveStatus: 0,
};

const extraInfoInitialState = {
  orderType: 0,
  extra: null,
  tips: {},
  selectedList: [],
  expectedCashCoupon: null,
  expectedCashList: [],
  giftCount: 0,
  giftList: [],
  cashList: [],
  cashId: null,
  postageList: [],
  postageId: null,
  loadStatus: 0,
};

const cartListInitialState = {
  list: null,
  selection: {},
  cartItems: {},
  cartItemDetails: {},
  number: 0,
  mergeProductMaster: cartMergeInitialState,
  activities: {},
  activityDetails: {},
  extraInfo: extraInfoInitialState,
  loadStatus: 0,
  saveStatus: 0,
};
const cartItemInitialState = {
  cartEditStatus: 0,
  saveStatus: 0,
  willChangeNumber: 0,
};

const activityDetailInitialState = {
  list: null,
  loadStatus: 0,
  saveStatus: 0,
};

const shareInitialState = {
  loadStatus: 0,
  detail: null,
};

const manjLevelsInitialState = {
  loadStatus: 0,
  discountList: null,
}

function cartReducer(state = cartListInitialState, action) {
  switch (action.type) {
    case 'LOAD_CART_LIST': {
      if (action.cartType !== 1) {
        return state;
      }

      return {
        ...state,
        loadStatus: 1,
      };
    }
    case 'LOAD_CART_LIST_COMPLETION': {
      const { error, list, cartType } = action;
      if (cartType !== 1) {
        return state;
      }

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const listContent = list.reduce(
        (content, { activityId, cartVo, cxActivityVo }) => {
          cartVo.forEach(({ code, number }) => {
            content.cartItemDetails[code] = {
              ...cartItemInitialState,
              willChangeNumber: number,
              activityId,
            };
            content.cartItems[code] = {
              number,
            };
          });

          if (activityId) {
            content.activities[activityId] = {
              ...(cxActivityVo || {}),
            };
          }
          let activity = {
            ...(activityId && { activityId }),
            cartCodes: cartVo.map(({ code }) => code),
          };
          content.activityList.push(activity);
          return content;
        },
        { cartItems: {}, cartItemDetails: {}, activityList: [], activities: {} }
      );

      return {
        ...state,
        list: listContent.activityList,
        cartItems: listContent.cartItems,
        cartItemDetails: listContent.cartItemDetails,
        activities: listContent.activities,
        loadStatus: 2,
      };
    }

    case 'SET_STORAGE_CART_SELECTION': {
      const { storageSelection, cartType } = action;

      if (cartType !== 1) {
        return state;
      }

      return {
        ...state,
        selection: storageSelection,
      };
    }

    case 'UPDATE_CART_SELECTION': {
      const { updateList, cartType } = action;

      if (cartType !== 1) {
        return state;
      }

      let selection = { ...state.selection };
      updateList.forEach(code => {
        selection[code] = true;
      });
      return {
        ...state,
        selection,
      };
    }
    case 'UPDATE_CART_UNSELECTION': {
      const { updateList, cartType } = action;

      if (cartType !== 1) {
        return state;
      }

      let selection = { ...state.selection };
      updateList.forEach(code => {
        delete selection[code];
      });

      return {
        ...state,
        selection,
      };
    }

    case 'ADD_CART':
    case 'ADD_CART_DEFAULT_GIFT': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'ADD_CART_COMPLETION':
    case 'ADD_CART_DEFAULT_GIFT_COMPLETION': {
      const { error, addList, data, cartType } = action;

      if (cartType !== 1) {
        return state;
      }

      if (error) {
        return {
          ...state,
          saveStatus: 0,
        };
      }

      let selection = { ...state.selection };
      addList.forEach(({ code }) => {
        if (!selection[code]) {
          selection[code] = true;
        }
      });

      return {
        ...state,
        selection,
        number: data.number,
        saveStatus: 2,
      };
    }

    case 'REMOVE_CART': {
      const { removeList, cartType } = action;

      if (cartType !== 1) {
        return {
          ...state,
          saveStatus: 1,
        };
      }

      return {
        ...state,
        cartItemDetails: removeList.reduce(
          (obj, { code }) => {
            const oldItem = state.cartItemDetails[code];
            return {
              ...obj,
              [code]: {
                ...oldItem,
                saveStatus: 1,
              },
            };
          },
          { ...state.cartItemDetails }
        ),
        saveStatus: 1,
      };
    }
    case 'REMOVE_CART_COMPLETION': {
      const { removeList, error, data, cartType } = action;

      if (cartType !== 1) {
        return {
          ...state,
          saveStatus: 0,
        };
      }

      if (error) {
        return {
          ...state,
          cartItemDetails: removeList.reduce(
            (obj, { code }) => {
              const oldItem = state.cartItemDetails[code];
              return {
                ...obj,
                [code]: {
                  ...oldItem,
                  saveStatus: 0,
                },
              };
            },
            { ...state.cartItemDetails }
          ),
          saveStatus: 0,
        };
      }

      let selection = { ...state.selection };
      removeList.map(({ code }) => {
        selection[code] && delete selection[code];
        return code;
      });

      return {
        ...state,
        cartItemDetails: removeList.reduce(
          (obj, { code }) => {
            const oldItem = state.cartItemDetails[code];
            return {
              ...obj,
              [code]: {
                ...oldItem,
                saveStatus: 2,
                cartEditStatus: 0,
              },
            };
          },
          { ...state.cartItemDetails }
        ),
        selection,
        number: data.number,
        saveStatus: 2,
      };
    }

    case 'EDIT_CART_ITEM': {
      const { code, cartType } = action;

      if (cartType !== 1) {
        return state;
      }

      return {
        ...state,
        cartItemDetails: {
          ...state.cartItemDetails,
          [code]: {
            ...state.cartItemDetails[code],
            cartEditStatus: 1,
          },
        },
      };
    }
    case 'UPDATE_CART_ITEM': {
      const { code, cartType } = action;

      if (cartType !== 1) {
        return state;
      }

      return {
        ...state,
        cartItemDetails: {
          ...state.cartItemDetails,
          [code]: {
            ...state.cartItemDetails[code],
            saveStatus: 1,
          },
        },
      };
    }
    case 'UPDATE_CART_ITEM_COMPLETION': {
      const { error, code, number, data, cartType } = action;

      if (cartType !== 1) {
        return state;
      }

      let numberObj;
      if (!error) {
        numberObj = { number: data.number };
      }

      return {
        ...state,
        cartItems: {
          ...state.cartItems,
          [code]: {
            ...state.cartItems[code],
            number,
          },
        },
        cartItemDetails: {
          ...state.cartItemDetails,
          [code]: {
            ...state.cartItemDetails[code],
            cartEditStatus: error ? 1 : 0,
            saveStatus: error ? 0 : 2,
            willChangeNumber: number,
          },
        },
        ...numberObj,
      };
    }
    case 'UPDATE_CART_NUMBER': {
      const { code, number, cartType } = action;

      if (cartType !== 1) {
        return state;
      }

      return {
        ...state,
        cartItemDetails: {
          ...state.cartItemDetails,
          [code]: {
            ...state.cartItemDetails[code],
            willChangeNumber: number,
          },
        },
      };
    }
    case 'LOAD_CART_NUMBER_COMPLETION': {
      const { error, data, cartType } = action;

      if (cartType !== 1) {
        return state;
      }

      if (error) {
        return state;
      }

      const { number } = data;
      return {
        ...state,
        number,
      };
    }
    case 'LOAD_CART_MERGE_PRODUCT_LIST': {
      const { cartType, willReload, query } = action;

      if (cartType !== 1) {
        return state;
      }

      if (!willReload) {
        return {
          ...state,
          mergeProductMaster: {
            ...state.mergeProductMaster,
            loadStatus: 1,
          },
        };
      }

      return {
        ...state,
        mergeProductMaster: {
          ...state.mergeProductMaster,
          loadStatus: 1,
          query: {
            ...state.mergeProductMaster.query,
            ...query,
          },
          list: null,
        },
      };
    }

    case 'LOAD_CART_MERGE_PRODUCT_LIST_COMPLETION': {
      const { error, data, cartType } = action;

      if (cartType !== 1) {
        return state;
      }

      if (error) {
        return {
          ...state,
          mergeProductMaster: {
            ...state.mergeProductMaster,
            loadStatus: 0,
          },
        };
      }

      const idList = data.listData.map(product => product.code);

      return {
        ...state,
        mergeProductMaster: {
          ...state.mergeProductMaster,
          loadStatus: 2,
          data: {
            ...data,
            listData: idList,
          },
        },
      };
    }
    case 'ADD_CART_MERGE': {
      const { cartType } = action;

      if (cartType !== 1) {
        return state;
      }

      return {
        ...state,
        mergeProductMaster: {
          ...state.mergeProductMaster,
          saveStatus: 1,
        },
      };
    }
    case 'ADD_CART_MERGE_COMPLETION': {
      const { error, cartType } = action;

      if (cartType !== 1) {
        return state;
      }

      return {
        ...state,
        mergeProductMaster: {
          ...state.mergeProductMaster,
          saveStatus: error ? 0 : 2,
        },
      };
    }
    case 'LOAD_CART_ACTIVITY_GIFT_LIST': {
      const { activityId } = action;
      const prevState =
        state.activityDetails[activityId] || activityDetailInitialState;

      return {
        ...state,
        activityDetails: {
          ...state.activityDetails,
          [activityId]: {
            ...prevState,
            loadStatus: 1,
          },
        },
      };
    }
    case 'LOAD_CART_ACTIVITY_GIFT_LIST_COMPLETION': {
      const { activityId, error, list } = action;
      const prevState =
        state.activityDetails[activityId] || activityDetailInitialState;

      if (error) {
        return {
          ...state,
          activityDetails: {
            ...state.activityDetails,
            [activityId]: {
              ...prevState,
              loadStatus: 0,
            },
          },
        };
      }

      let infoList = list.map(item => {
        const list = item.list.map(({ code }) => code);
        return {
          ...item,
          list,
        };
      });
      return {
        ...state,
        activityDetails: {
          ...state.activityDetails,
          [activityId]: {
            ...prevState,
            list: infoList,
            loadStatus: 2,
          },
        },
      };
    }
    case 'PICK_CART_ACTIVITY_GIFT': {
      const { activityId } = action;
      const prevState =
        state.activityDetails[activityId] || activityDetailInitialState;

      return {
        ...state,
        activityDetails: {
          ...state.activityDetails,
          [activityId]: {
            ...prevState,
            saveStatus: 1,
          },
        },
      };
    }
    case 'PICK_CART_ACTIVITY_GIFT_COMPLETION': {
      const { activityId, error } = action;
      const prevState =
        state.activityDetails[activityId] || activityDetailInitialState;

      return {
        ...state,
        activityDetails: {
          ...state.activityDetails,
          [activityId]: {
            ...prevState,
            saveStatus: error ? 0 : 2,
          },
        },
      };
    }
    case 'LOAD_CART_EXTRA_INFO': {
      if (action.cartType !== 1) {
        return state;
      }

      return {
        ...state,
        extraInfo: {
          ...state.extraInfo,
          loadStatus: 1,
        },
      };
    }
    case 'LOAD_CART_EXTRA_INFO_COMPLETION': {
      const {
        error,
        data,
        cartType,
        orderType,
        selectedList,
        giftList,
        recoverData,
      } = action;

      if (cartType !== 1) {
        return state;
      }

      if (error) {
        return {
          ...state,
          ...(selectedList && {
            selection: selectedList.reduce((obj, { code }) => {
              obj[code] = true;
              return obj;
            }, {}),
          }),
          extraInfo: {
            ...state.extraInfo,
            loadStatus: 0,
          },
        };
      }

      let res = {};
      let defaultCashId, defaultPostageId;

      data.order && (res.extra = data.order);
      data.tips && (res.tips = data.tips);

      if (data.coupon) {
        const {
          productCouponNum,
          cashCouponList,
          postageCouponList,
          cashCouponId,
          postageCouponId,
          expectedCashCoupon,
          expectedCashCouponList,
          restMoney,
        } = data.coupon;

        if (recoverData.cashId) {
          defaultCashId = recoverData.cashId;
        } else {
          defaultCashId = cashCouponId ? cashCouponId : null;
        }

        if (recoverData.postageId && !recoverData.select) {
          defaultPostageId = recoverData.postageId;
        } else {
          defaultPostageId = postageCouponId ? postageCouponId : null;
        }

        res.cashList = (cashCouponList || []).map(coupon => coupon.code);
        res.postageList = (postageCouponList || []).map(coupon => coupon.code);
        productCouponNum && (res.giftCount = productCouponNum);
        res.expectedCashList = (expectedCashCouponList || []).map(
          coupon => coupon.code
        );
        res.expectedCashCoupon = expectedCashCoupon
          ? {
              ...expectedCashCoupon,
              restMoney,
            }
          : null;
      }

      return {
        ...state,
        extraInfo: {
          ...state.extraInfo,
          ...res,
          cashId: defaultCashId,
          postageId: defaultPostageId,
          orderType,
          selectedList,
          giftList,
          loadStatus: 2,
        },
      };
    }
    case 'RESET_CART_EXTRA_INFO': {
      if (action.cartType !== 1) {
        return state;
      }

      return {
        ...state,
        extraInfo: extraInfoInitialState,
      };
    }
    case 'PICK_CART_EXTRA_INFO_CASH': {
      if (action.cartType !== 1) {
        return state;
      }

      return {
        ...state,
        extraInfo: {
          ...state.extraInfo,
          cashId: action.cashId || null,
        },
      };
    }
    case 'PICK_CART_EXTRA_INFO_POSTAGE': {
      if (action.cartType !== 1) {
        return state;
      }

      return {
        ...state,
        extraInfo: {
          ...state.extraInfo,
          postageId: action.postageId || null,
        },
      };
    }
    default:
      return state;
  }
}

function overseaCartReducer(state = cartListInitialState, action) {
  switch (action.type) {
    case 'DEINIT_CART_LIST': {
      if (action.cartType !== 2) {
        return state;
      }

      return cartListInitialState;
    }
    case 'LOAD_CART_LIST': {
      if (action.cartType !== 2) {
        return state;
      }

      return {
        ...state,
        loadStatus: 1,
      };
    }
    case 'LOAD_CART_LIST_COMPLETION': {
      const { error, list, cartType } = action;
      if (cartType !== 2) {
        return state;
      }

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const listContent = list.reduce(
        (content, { code, number }) => {
          content.cartItemDetails[code] = {
            ...cartItemInitialState,
            willChangeNumber: number,
          };
          content.cartItems[code] = {
            number,
          };

          content.list.push(code);
          return content;
        },
        { list: [], cartItems: {}, cartItemDetails: {} }
      );

      return {
        ...state,
        list: listContent.list,
        cartItems: listContent.cartItems,
        cartItemDetails: listContent.cartItemDetails,
        loadStatus: 2,
      };
    }

    case 'SET_STORAGE_CART_SELECTION': {
      const { storageSelection, cartType } = action;

      if (cartType !== 2) {
        return state;
      }

      return {
        ...state,
        selection: storageSelection,
      };
    }

    case 'UPDATE_CART_SELECTION': {
      const { updateList, cartType } = action;

      if (cartType !== 2) {
        return state;
      }

      let selection = { ...state.selection };
      updateList.forEach(code => {
        selection[code] = true;
      });
      return {
        ...state,
        selection,
      };
    }

    case 'UPDATE_CART_UNSELECTION': {
      const { updateList, cartType } = action;

      if (cartType !== 2) {
        return state;
      }

      let selection = { ...state.selection };
      updateList.forEach(code => {
        delete selection[code];
      });

      return {
        ...state,
        selection,
      };
    }

    case 'ADD_CART':
    case 'ADD_CART_DEFAULT_GIFT': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'ADD_CART_COMPLETION':
    case 'ADD_CART_DEFAULT_GIFT_COMPLETION': {
      const { error, addList, data, cartType } = action;

      if (cartType !== 2) {
        return state;
      }

      if (error) {
        return {
          ...state,
          saveStatus: 0,
        };
      }

      let selection = { ...state.selection };
      addList.forEach(({ code }) => {
        if (!selection[code]) {
          selection[code] = true;
        }
      });
      return {
        ...state,
        selection,
        number: data.number,
        saveStatus: 2,
      };
    }

    case 'REMOVE_CART': {
      const { removeList, cartType } = action;

      if (cartType !== 2) {
        return {
          ...state,
          saveStatus: 1,
        };
      }

      return {
        ...state,
        cartItemDetails: removeList.reduce(
          (obj, { code }) => {
            const oldItem = state.cartItemDetails[code];
            return {
              ...obj,
              [code]: {
                ...oldItem,
                saveStatus: 1,
              },
            };
          },
          { ...state.cartItemDetails }
        ),
        saveStatus: 1,
      };
    }
    case 'REMOVE_CART_COMPLETION': {
      const { removeList, error, data, cartType } = action;

      if (cartType !== 2) {
        return {
          ...state,
          saveStatus: 0,
        };
      }

      if (error) {
        return {
          ...state,
          cartItemDetails: removeList.reduce(
            (obj, { code }) => {
              const oldItem = state.cartItemDetails[code];
              return {
                ...obj,
                [code]: {
                  ...oldItem,
                  saveStatus: 0,
                },
              };
            },
            { ...state.cartItemDetails }
          ),
          saveStatus: 0,
        };
      }

      let selection = { ...state.selection };
      removeList.map(({ code }) => {
        selection[code] && delete selection[code];
        return code;
      });

      return {
        ...state,
        cartItemDetails: removeList.reduce(
          (obj, { code }) => {
            const oldItem = state.cartItemDetails[code];
            return {
              ...obj,
              [code]: {
                ...oldItem,
                saveStatus: 2,
                cartEditStatus: 0,
              },
            };
          },
          { ...state.cartItemDetails }
        ),
        selection,
        number: data.number,
        saveStatus: 2,
      };
    }

    case 'EDIT_CART_ITEM': {
      const { code, cartType } = action;

      if (cartType !== 2) {
        return state;
      }

      return {
        ...state,
        cartItemDetails: {
          ...state.cartItemDetails,
          [code]: {
            ...state.cartItemDetails[code],
            cartEditStatus: 1,
          },
        },
      };
    }
    case 'UPDATE_CART_ITEM': {
      const { code, cartType } = action;

      if (cartType !== 2) {
        return state;
      }

      return {
        ...state,
        cartItemDetails: {
          ...state.cartItemDetails,
          [code]: {
            ...state.cartItemDetails[code],
            saveStatus: 1,
          },
        },
      };
    }
    case 'UPDATE_CART_ITEM_COMPLETION': {
      const { error, code, number, data, cartType } = action;

      if (cartType !== 2) {
        return state;
      }

      let numberObj;
      if (!error) {
        numberObj = { number: data.number };
      }
      return {
        ...state,
        cartItems: {
          ...state.cartItems,
          [code]: {
            ...state.cartItems[code],
            number,
          },
        },
        cartItemDetails: {
          ...state.cartItemDetails,
          [code]: {
            ...state.cartItemDetails[code],
            cartEditStatus: error ? 1 : 0,
            saveStatus: error ? 0 : 2,
            willChangeNumber: number,
          },
        },
        ...numberObj,
      };
    }
    case 'UPDATE_CART_NUMBER': {
      const { code, number, cartType } = action;

      if (cartType !== 2) {
        return state;
      }

      return {
        ...state,
        cartItemDetails: {
          ...state.cartItemDetails,
          [code]: {
            ...state.cartItemDetails[code],
            willChangeNumber: number,
          },
        },
      };
    }
    case 'LOAD_CART_NUMBER_COMPLETION': {
      const { error, data, cartType } = action;

      if (cartType !== 2) {
        return state;
      }

      if (error) {
        return state;
      }
      const { number } = data;
      return {
        ...state,
        number,
      };
    }
    case 'LOAD_CART_MERGE_PRODUCT_LIST': {
      const { cartType, willReload, query } = action;

      if (cartType !== 2) {
        return state;
      }

      if (!willReload) {
        return {
          ...state,
          mergeProductMaster: {
            ...state.mergeProductMaster,
            loadStatus: 1,
          },
        };
      }

      return {
        ...state,
        mergeProductMaster: {
          ...state.mergeProductMaster,
          loadStatus: 1,
          query: {
            ...state.mergeProductMaster.query,
            ...query,
          },
          list: null,
        },
      };
    }

    case 'LOAD_CART_MERGE_PRODUCT_LIST_COMPLETION': {
      const { error, data, cartType } = action;

      if (cartType !== 2) {
        return state;
      }

      if (error) {
        return {
          ...state,
          mergeProductMaster: {
            ...state.mergeProductMaster,
            loadStatus: 0,
          },
        };
      }

      const idList = data.listData.map(product => product.code);

      return {
        ...state,
        mergeProductMaster: {
          ...state.mergeProductMaster,
          loadStatus: 2,
          data: {
            ...data,
            list: idList,
          },
        },
      };
    }
    case 'ADD_CART_MERGE': {
      const { cartType } = action;

      if (cartType !== 2) {
        return state;
      }

      return {
        ...state,
        mergeProductMaster: {
          ...state.mergeProductMaster,
          saveStatus: 1,
        },
      };
    }
    case 'ADD_CART_MERGE_COMPLETION': {
      const { error, cartType } = action;

      if (cartType !== 2) {
        return state;
      }

      return {
        ...state,
        mergeProductMaster: {
          ...state.mergeProductMaster,
          saveStatus: error ? 0 : 2,
        },
      };
    }
    case 'LOAD_CART_EXTRA_INFO': {
      if (action.cartType !== 2) {
        return state;
      }

      return {
        ...state,
        extraInfo: {
          ...state.extraInfo,
          loadStatus: 1,
        },
      };
    }
    case 'LOAD_CART_EXTRA_INFO_COMPLETION': {
      const {
        error,
        data,
        cartType,
        orderType,
        selectedList,
        giftList,
        recoverData,
      } = action;

      if (cartType !== 2) {
        return state;
      }

      if (error) {
        return {
          ...state,
          ...(selectedList && {
            selection: selectedList.reduce((obj, { code }) => {
              obj[code] = true;
              return obj;
            }, {}),
          }),
          extraInfo: {
            ...state.extraInfo,
            loadStatus: 0,
          },
        };
      }

      let res = {};
      let defaultCashId, defaultPostageId;

      data.order && (res.extra = data.order);
      data.tips && (res.tips = data.tips);

      if (data.coupon) {
        const {
          productCouponNum,
          cashCouponList,
          postageCouponList,
          cashCouponId,
          postageCouponId,
          expectedCashCoupon,
          expectedCashCouponList,
          restMoney,
        } = data.coupon;

        if (recoverData.cashId) {
          defaultCashId = recoverData.cashId;
        } else {
          defaultCashId = cashCouponId ? cashCouponId : null;
        }

        if (recoverData.postageId) {
          defaultPostageId = recoverData.postageId;
        } else {
          defaultPostageId = postageCouponId ? postageCouponId : null;
        }

        res.cashList = (cashCouponList || []).map(coupon => coupon.code);
        res.postageList = (postageCouponList || []).map(coupon => coupon.code);
        productCouponNum && (res.giftCount = productCouponNum);
        res.expectedCashList = (expectedCashCouponList || []).map(
          coupon => coupon.code
        );
        res.expectedCashCoupon = expectedCashCoupon
          ? {
              ...expectedCashCoupon,
              restMoney,
            }
          : null;
      }

      return {
        ...state,
        extraInfo: {
          ...state.extraInfo,
          ...res,
          cashId: defaultCashId,
          postageId: defaultPostageId,
          orderType,
          selectedList,
          giftList,
          loadStatus: 2,
        },
      };
    }
    case 'RESET_CART_EXTRA_INFO': {
      if (action.cartType !== 2) {
        return state;
      }

      return {
        ...state,
        extraInfo: extraInfoInitialState,
      };
    }
    case 'PICK_CART_EXTRA_INFO_CASH': {
      if (action.cartType !== 2) {
        return state;
      }

      return {
        ...state,
        extraInfo: {
          ...state.extraInfo,
          cashId: action.cashId || null,
        },
      };
    }
    case 'PICK_CART_EXTRA_INFO_POSTAGE': {
      if (action.cartType !== 2) {
        return state;
      }

      return {
        ...state,
        extraInfo: {
          ...state.extraInfo,
          postageId: action.postageId || null,
        },
      };
    }
    default:
      return state;
  }
}

function shareReducer(state = shareInitialState, action) {
  switch (action.type) {
    case 'RESET_CART_SHARE': {
      return shareInitialState;
    }

    case 'LOAD_CART_SHARE_INFO': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_CART_SHARE_INFO_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        detail: {
          ...data,
          listData: data.listData.map(item => ({
            code: item.code,
            number: item.number,
          })),
        },
      };
    }

    default:
      return state;
  }
}

function manjLevelsReducer(state = manjLevelsInitialState, action) {
  switch (action.type) {
    case 'LOAD_CART_MAN_J_LEVELS': {
      return {
        ...state,
        loadStatus: 1
      }
    }
    case 'LOAD_CART_MAN_J_LEVELS_COMPLETION': {
      const { error, list } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0
        }
      }

      return {
        ...state,
        loadStatus: 2,
        discountList: list
      }
    }
    default:
      return state
  }
}

export default combineReducers({
  cart: cartReducer,
  overseaCart: overseaCartReducer,
  share: shareReducer,
  manjLevels: manjLevelsReducer,
});
